import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export function ExampleProcesses({ t }) {
  return (
    <section id="examples" className="relative section-pad">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col gap-6 mb-12 md:mb-16 max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-[#00E5FF]" />
            <span className="eyebrow">{t.examples.eyebrow}</span>
          </div>
          <h2
            className="text-white font-semibold leading-[1.05] tracking-tight"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: "clamp(30px, 4.5vw, 48px)",
            }}
          >
            {t.examples.heading}
          </h2>
          <p
            className="text-[#9BA1A6] leading-relaxed"
            style={{ fontFamily: "'Manrope', sans-serif", fontSize: "17px" }}
          >
            {t.examples.sub}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.examples.items.map((label, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.04, ease: "easeOut" }}
              data-testid={`example-${i}`}
              className="group bg-[#1C2331] border border-white/10 rounded-sm p-6 hover:border-[#00E5FF]/50 transition-all duration-300"
            >
              <div className="flex items-start justify-between gap-3">
                <span
                  className="text-white text-sm font-semibold leading-snug"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {label}
                </span>
                <ArrowUpRight
                  size={16}
                  className="text-[#9BA1A6] group-hover:text-[#00E5FF] transition-colors shrink-0"
                />
              </div>
              <div
                className="mt-4 text-[10px] uppercase tracking-[0.22em] text-[#00E5FF] font-semibold"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {String(i + 1).padStart(2, "0")}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
